import React from "react";
import { Link } from "react-router-dom";


function ComingSoon() {
  return (
    <div className="container-fluid comingsoon" style={{ height: "100vh" }}>
      <div className="row h-100 justify-content-center align-items-center">
        <div className="col-12 text-center">
       
          <img
            width="100"
            height="100"
            src="https://img.icons8.com/glyph-neue/50/12B886/positive-dynamic.png"
            alt="positive-dynamic"
          />

     
          <h1 className="heading">
            Progress Is <span>Coming Soon</span>
          </h1>

        
          <p className="sub_heading" style={{fontSize:"1.2rem"}}>
            It’s almost ready...
          </p>

          <div className="company-info" style={{ marginBottom: "20px" }}>
            <h3 className="heading" style={{fontSize:25}}>About Us</h3>
            <p className="sub_heading "  style={{fontSize:"1.2rem"}}>
              We are a tech company working on innovative solutions to make your life easier.
            </p>
            <p className="sub_heading "  style={{fontSize:"1.2rem"}}>
             Our new website will offer exciting features soon.
            </p>
          </div>
          <div className="contact-info my-3" style={{ marginBottom: "20px" }}>
            <p  style={{fontWeight:700,color:"#001f3f"}}>
              For inquiries, email us at: <span className=" ps-1"><Link to="mailto:info@digitalmonk.biz">info@digitalmonk.biz</Link></span>
              
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
